import { treaty } from "@elysiajs/eden";
import type { App } from "@majourneys/api";
import type { HeaderBuilder } from "./types";

export type ApiClient = ReturnType<typeof treaty<App>>;

export interface CreateClientOptions {
  fetcher?: typeof fetch;
  headers?: HeaderBuilder;
}

export function createClient(
  baseUrl: string,
  options?: CreateClientOptions,
): ApiClient {
  return treaty<App>(baseUrl, {
    fetcher: options?.fetcher,
    headers: options?.headers,
    // Eden's date revival turns date-like strings ("2026-07-13") into Date
    // objects at runtime while the shared zod types say string — rendering
    // such a field crashes React ("Objects are not valid as a React child").
    // Keep wire values as strings, matching the types.
    parseDate: false,
  });
}
